import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect as s, useState as n } from "react";

var u = function u(e, t) {
  var _n = n(!1),
      _n2 = _slicedToArray(_n, 2),
      i = _n2[0],
      r = _n2[1];

  return s(function () {
    r(t.includes(e.viewport));
  }, [e.viewport, t]), i;
};

export { u as useBreakpoint };